import React, { useState } from 'react'
import style from './Settings.module.scss'
import { Radio } from 'antd'
import SelectMyEmployee from '../../components/Settings/SelectMyEmployee'
import SelectMyProject from '../../components/Settings/SelectMyProject'

const Settings = () => {
  const [type, setType] = useState<'employee' | 'project'>('employee')

  return (
    <div className={style.wrapper}>
      <div className={style.buttonSet}>
        <Radio.Group value={type} onChange={(e) => setType(e.target.value)}>
          <Radio.Button value='employee'>Сотрудники</Radio.Button>
          <Radio.Button value='project'>Проекты</Radio.Button>
        </Radio.Group>
      </div>
      {type === 'employee' && (
        <div className={style.body}>
          <SelectMyEmployee />
        </div>
      )}
      {type === 'project' && (
        <div className={style.body}>
          <SelectMyProject />
        </div>
      )}
    </div>
  )
}

export default Settings
